import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { compare, getDay, addDays, startOfDay, OwaDate } from 'owa-datetime';
import { dateRangesOverlap } from 'owa-datetime-utils';
import { DateRangeType } from 'owa-calendarview-settings';
import { DayOfWeek } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

export function returnEventsInDateRange(
    rangeStart: OwaDate,
    rangeEnd: OwaDate,
    events: CalendarEvent[]
): CalendarEvent[] {
    return events
        .map(event => {
            return (event as unknown) as CalendarEvent;
        })
        .filter(event => {
            const eventDateRange = { start: event.Start, end: event.End };
            const range = { start: rangeStart, end: rangeEnd };
            return event && dateRangesOverlap(eventDateRange, range, false /*inclusive */) === 0;
        })
        .sort((e1, e2) => {
            // sort by start time
            return compare(e1.Start, e2.Start);
        });
}

export function splitEventsIntoDays(
    events: CalendarEvent[],
    rangeStart: OwaDate,
    rangeEnd: OwaDate,
    dateRangeType: DateRangeType,
    workweek: DayOfWeek[]
): { events: CalendarEvent[][]; dates: OwaDate[] } {
    let visibleEventsPerDay: CalendarEvent[][] = [];
    let dates: OwaDate[] = [];

    let i = 0;
    let visibleDayIndex = 0;
    let startOfRange = startOfDay(rangeStart);
    let date = startOfDay(rangeStart);
    while (compare(date, rangeEnd) < 0) {
        let endDate = addDays(date, 1);

        if (dateRangeType !== DateRangeType.WorkWeek || workweek.includes(getDay(date))) {
            dates.push(date);
            visibleEventsPerDay[visibleDayIndex] = returnEventsInDateRange(date, endDate, events);
            visibleDayIndex++;
        }

        i++;
        date = addDays(startOfRange, i);
    }

    return { events: visibleEventsPerDay, dates: dates };
}
